// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginRegister_wrapper__eqopg","link":"LoginRegister_link__ITETd","activeLink":"LoginRegister_activeLink__Ishah"};